export const form_value = {
    platform: 'LinkedIn',
    audience: 'Consultants',
    tone: 'professional',
    language: 'English',
    emoticons: false,
    hashtags: true,
    bulletPoints: true,
    postDescription: '',
};
